export const CErrorCodes = {
    TOKEN_EXPIRED: 'tokenExpired',
    EMAIL_EXISTS: 'UsersEmailAlreadyExist'
} as const;

